export interface Cell {
  uuid: string;
  name: string;
  internalName: string | null;
  customerUuid: string;
  customerName: string;
}

export interface NewCell {
  name: string;
  internalName?: string | null;
  customerUuid: string;
}

export const EMPTY_NEW_CELL: NewCell = {
  name: '',
  internalName: '',
  customerUuid: '',
};
